import { Authorization } from "../../common/AuthorizationCpt";
import IconArrowRight from "../../images/icon_arrow_right_gray.svg";
import { DocumentManagementTypes } from "../../utils/constants";
import { Container, Item } from "./DocumentManagementSideMenuStyles";

const {
  SENASA_RESTRICTION,
  ELECTRONIC_MANDATE,
  THIRD_PARTY_AUTH,
  CREDIT_AUTH,
} = DocumentManagementTypes;

function DocumentManagementSideMenu(props) {
  const { activeMenu, updateActiveMenu } = props;
  return (
    <>
      <Container role="menu" className="menu-dt">
        <Authorization actions={["dam.get_dam_senasa_agent"]}>
          <Item
            active={activeMenu === SENASA_RESTRICTION}
            onClick={() => updateActiveMenu(SENASA_RESTRICTION)}
          >
            RESTRICCIÓN SENASA
            <img src={IconArrowRight} alt="right arrow" />
          </Item>
        </Authorization>
        <Authorization actions={["dam.get_dam_electronic_mandate_agent"]}>
          <Item
            active={activeMenu === ELECTRONIC_MANDATE}
            onClick={() => updateActiveMenu(ELECTRONIC_MANDATE)}
          >
            MANDATO ELECTRÓNICO
            <img src={IconArrowRight} alt="right arrow" />
          </Item>
        </Authorization>
        <Authorization actions={["volante.get_volante_third_party_auth"]}>
          <Item
            active={activeMenu === THIRD_PARTY_AUTH}
            onClick={() => updateActiveMenu(THIRD_PARTY_AUTH)}
          >
            AUTORIZACIONES DE FACTURACIÓN A TERCEROS
            <img src={IconArrowRight} alt="right arrow" />
          </Item>
        </Authorization>
        <Authorization actions={["invoice.get_invoice_payment_status"]}>
          <Item
            active={activeMenu === CREDIT_AUTH}
            onClick={() => updateActiveMenu(CREDIT_AUTH)}
          >
            AUTORIZACIONES DE USO DE CRÉDITO
            <img src={IconArrowRight} alt="right arrow" />
          </Item>
        </Authorization>
      </Container>
    </>
  );
}

export default DocumentManagementSideMenu;
